import React from 'react';

const SIZE_LOGO = 'h-24';

interface HeaderProps {
  logoText: string;
  logoUrl?: string;
}

export const Header: React.FC<HeaderProps> = ({ logoText, logoUrl }) => {
  return (
    <div className="mb-6 flex justify-center">
      <img 
        src={logoUrl || '/logo_client.avif'} 
        alt={logoText}
        className={`${SIZE_LOGO} w-auto object-contain`}
        onError={(e) => {
          // Fallback to local logo if CDN URL fails
          const target = e.target as HTMLImageElement;
          if (target.src !== '/logo_client.avif') {
            target.src = '/logo_client.avif';
          }
        }}
      />
    </div>
  );
};
